
export * from './functions.any';

/**
 * Loads config.js from a specific remote server.
 *
 * @param {string} _url - The URL to load.
 * @returns {Promise<Object>}
 */
// eslint-disable-next-line require-await -- async by contract: callers rely on the returned promise
export async function loadConfig(_url: string): Promise<Object> {
    // Return "the config.js file" from the global scope - that is how the
    // Web app on both the client and the server was implemented before the
    // React Native app was even conceived.
    return window.config;
}

/**
 * Loads interface_config.js from the current web page context.
 *
 * @param {string} _url - The URL to load.
 * @returns {Promise<Object>}
 */
// eslint-disable-next-line require-await -- async by contract: callers rely on the returned promise
export async function loadinterfaceConfig(_url: string): Promise<Object> {
    return window.interfaceConfig;
}
